import {ComponentStore} from '@ngrx/component-store';
import {ReportTableRowParametersChannelState} from './report-table-row-parameters-channel';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../../shared/store/store';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {Serializer, Serializers} from '../../../../../../shared/interfaces/serializer';
import {Channel} from '../../../../../../shared/interfaces/channel';
import {selectChannelsLoaded, selectChannelsNotRequired} from '../../../../../../shared/store/channels/channels.selectors';
import {filter, tap} from 'rxjs/operators';

@Injectable()
export class ReportTableRowParametersChannelStore extends ComponentStore<ReportTableRowParametersChannelState> {
  public readonly channel$: Observable<string> = this.select((state: ReportTableRowParametersChannelState): string => state.channel);
  public readonly slug$: Observable<string> = this.select((state: ReportTableRowParametersChannelState): string => state.slug);

  private readonly _channels$: Observable<Serializers<Channel>> = this._store.select(selectChannelsNotRequired);
  private readonly _channelsLoaded$: Observable<boolean> = this._store.select(selectChannelsLoaded);

  private readonly _init: (channel: string) => void = this.effect((params$: Observable<string>): Observable<[Serializers<Channel>, boolean]> => params$.pipe(
    switchMap((channelParam: string): Observable<[Serializers<Channel>, boolean]> => this._channels$.pipe(
      withLatestFrom(this._channelsLoaded$),
      filter(([_, loaded]: [Serializers<Channel>, boolean]): boolean => loaded),
      tap(([channels, _]: [Serializers<Channel>, boolean]): void => {
        const channel: Serializer<Channel> = channels.find((channel: Serializer<Channel>): boolean => channel.attributes.slug == channelParam);

        this.patchState({ channel: channel.attributes.name, slug: channel.attributes.slug });
      })
    ))
  ))

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      channel: null,
      slug: null
    });
  }

  public init(channel: string): void {
    this._init(channel);
  }

}
